<div fxLayout="column" fxLayoutAlign="space-around center">
    <div fxFlex></div>
    <div fxFlex>
        <ng-content></ng-content>
    </div>
    <div fxFlex></div>
</div>
